export const getNextYear = (): number => {
    const currentYear = new Date().getFullYear();

    return currentYear + 1;
}

export const getLastDayOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}

// JavaScript rolls an overflowing day into the next month: 29 February + 1 year becomes 1 March,
// 31 January + 1 month becomes 3 March. setDate(0) clamps back to the intended month's last day.
export const addYears = (date: Date, years: number) => {
    const result = new Date(date.getFullYear() + years, date.getMonth(), date.getDate())
    if (result.getMonth() !== date.getMonth()) {
        result.setDate(0)
    }

    return result
}

export const addMonths = (date: Date, months: number) => {
    const expectedMonth = new Date(date.getFullYear(), date.getMonth() + months, 1).getMonth()
    const result = new Date(date.getFullYear(), date.getMonth() + months, date.getDate())
    if (result.getMonth() !== expectedMonth) {
        result.setDate(0)
    }

    return result
}
